import { Routes } from '@angular/router';
import { MessagesPage } from './messages.page';
import { v2On } from '../v2/ui-v2.guard';

export const messagesRoutes: Routes = [
    {
        path: 'messages',
        component: MessagesPage,
        children: [
            {
                path: '',
                redirectTo: 'list',
                pathMatch: 'full'
            },
            {
                path: 'list',
                canMatch: [v2On],
                loadComponent: () => import('../v2/pages/messages/conversations-list-v2.page').then(m => m.ConversationsListV2Page)
            },
            {
                path: 'list',
                loadComponent: () => import('./conversations-list/conversations-list.page').then(m => m.ConversationsListPage)
            },
            {
                path: 'chat',
                canMatch: [v2On],
                loadComponent: () => import('../v2/pages/messages/chat-v2.page').then(m => m.ChatV2Page)
            },
            {
                path: 'chat',
                loadComponent: () => import('./chat/chat.page').then(m => m.ChatPage)
            },
            {
                path: 'compose',
                canMatch: [v2On],
                loadComponent: () => import('../v2/pages/messages/compose-v2.page').then(m => m.ComposeV2Page)
            },
            {
                path: 'compose',
                loadComponent: () => import('./compose/compose.page').then(m => m.ComposePage)
            },
            {
                path: 'feeds',
                canMatch: [v2On],
                redirectTo: 'list',
                pathMatch: 'full'
            },
            {
                path: 'feeds',
                loadComponent: () => import('./feeds/feeds.page').then(m => m.FeedsPage)
            },
            {
                path: 'feeds/post/:id',
                canMatch: [v2On],
                loadComponent: () => import('../v2/pages/messages/post-detail-v2.page').then(m => m.PostDetailV2Page)
            },
            {
                path: 'feeds/post/:id',
                loadComponent: () => import('./post-detail/post-detail.page').then(m => m.PostDetailPage)
            },
            {
                path: 'feeds/new',
                canMatch: [v2On],
                loadComponent: () => import('../v2/pages/messages/new-post-v2.page').then(m => m.NewPostV2Page)
            },
            {
                path: 'feeds/new',
                loadComponent: () => import('./new-post/new-post.page').then(m => m.NewPostPage)
            },
            {
                path: 'reports',
                canMatch: [v2On],
                loadComponent: () => import('../v2/pages/messages/reports-v2.page').then(m => m.ReportsV2Page)
            },
            {
                path: 'reports',
                loadComponent: () => import('./reports/reports.page').then(m => m.ReportsPage)
            }
        ]
    }
];
